module.exports = __webpack_public_path__ + "static/media/naman_modi.e50db8a6.jpg";